import styled from 'styled-components';

export const Cross = styled.button<{ open?: boolean }>`
  background-color: inherit;
  border: none;
  &:hover {
    cursor: pointer;
    img {
      filter: invert(100%) sepia(95%) saturate(14%) hue-rotate(209deg)
        brightness(104%) contrast(100%);
    }
  }
  align-self: ${(props) => (props.open ? 'flex-end' : 'auto')};
  margin-top: 24px;
  margin-right: 24px;
  padding: 0px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 24px;
  border-bottom: solid 1px
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N300
        : props.theme.atlas.semantic.color.surface.variant};
`;

export const Title = styled.h3`
  margin: 0;
  font-weight: 500;
  font-size: 24px;
  font-family: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newTypography.textStyleBody.fontFamily
      : props.theme.atlas.typography.semantic.bodySmall.fontFamily};
`;

export const Subtitle = styled.h4`
  margin: 7px 0px 31px 0px;
  font-weight: 500;
  font-size: 14px;
  font-family: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newTypography.textStyleBody.fontFamily
      : props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N500
      : props.theme.atlas.semantic.color.type.disabled};
`;

export const ChildrenContainer = styled.div<{ overflowY?: boolean }>`
  height: 100%;
  padding-left: 24px;
  padding-right: 24px;
  overflow-y: ${(props) => (props.overflowY ? 'scroll' : 'visible')};
  padding-top: 0px;
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex: 1;
  margin-top: 24px;
  margin-bottom: 96px;
  column-gap: 10px;
  width: 50%;
  margin-left: auto;
`;
